import { ELEMENTSTYPESIDS } from 'projects/phdsoft/common/src/lib/shared/constants/elementsTypesIds'
import { NonWorkableElement } from '../NonWorkableElement'
import { WorkableElement } from '../WorkableElement'
import * as THREE from '@phdsoft/three';

export class WeightAreaElement extends NonWorkableElement {

  insertionMethod: string
  elementNameId: string
  elementCategory: string
  targetElements: string[]
  createdAt: Date
  Label: string
  ActionId: string
  Weight:number


  public VerifyProperties() {
    throw new Error('Method not implemented.')
  }

  constructor(
    id: string,
    mesh: THREE.Mesh,
    material: THREE.Material,
    regionId: string,
    sectionId: string, 
    totalWeight:number
  ) {
    super(mesh, material, id)
    this.Guid = id
    this.regionId = regionId
    this.SectionId = sectionId
    this.TypeId = ELEMENTSTYPESIDS.WEIGHTAREAELEMENT
    this.Weight = totalWeight
    // this.targetElements = targetElements
  }
}
